import { EntityTypeEnum } from "@app/projects/enumerators";
import { NetworkIntegrityActionStatus } from "@app/projects/network-assessment/network-integrity/filters/networkIntegrityFilterConstants";

/**
 * Selection mode for the include/exclude pattern.
 * - "unknown": Initial/default state, should be set before using
 * - "include": Only explicitly checked items are selected
 * - "exclude": ALL items are selected EXCEPT explicitly unchecked ones
 */
enum NetworkIntegrityProviderSelectionMode {
  Unknown = "unknown",
  Include = "include",
  Exclude = "exclude"
}

interface NetworkIntegrityProviderSelectionState {
  providerAndProviderSetVersionIds: Set<string>;
  selectionMode: NetworkIntegrityProviderSelectionMode;
}

interface NetworkIntegrityProviderSelectionStateDto {
  npiEntityType?: EntityTypeEnum | null;
  providerAndProviderSetVersionIds: string[];
  search?: string;
  selectionMode: NetworkIntegrityProviderSelectionMode;
  selectionCount: number;
  regionSetIds?: number[];
  specialtyCodes?: string[];
  actionStatus?: NetworkIntegrityActionStatus;
}

export {
  NetworkIntegrityProviderSelectionMode,
  NetworkIntegrityProviderSelectionState,
  NetworkIntegrityProviderSelectionStateDto
}